/**
 * Forge · Fase 1 · API client per workspaces / tasks
 * Endpoints: /api/kernel/workspaces
 */
import { useEffect, useState, useCallback } from "react";

const API = "" || "";

async function _json(path, opts = {}) {
  const r = await fetch(`${API}${path}`, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      ...(opts.headers || {}),
    },
  });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j?.detail || `${r.status} ${path}`);
  return j;
}

export const apiWorkspace = {
  list:    () => _json("/api/kernel/workspaces"),
  get:     (id) => _json(`/api/kernel/workspaces/${id}`),
  create:  (body) => _json("/api/kernel/workspaces", { method: "POST", body: JSON.stringify(body) }),
  patch:   (id, body) => _json(`/api/kernel/workspaces/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  archive: (id) => _json(`/api/kernel/workspaces/${id}`, { method: "DELETE" }),
  timeline:(id, ev) => _json(`/api/kernel/workspaces/${id}/timeline`,
                             { method: "POST", body: JSON.stringify(ev) }),
};

export const apiTask = {
  list:   (wsId) => _json(`/api/kernel/workspaces/${wsId}/tasks`),
  create: (wsId, body) => _json(`/api/kernel/workspaces/${wsId}/tasks`,
                                { method: "POST", body: JSON.stringify(body) }),
  patch:  (wsId, id, body) => _json(`/api/kernel/workspaces/${wsId}/tasks/${id}`,
                                    { method: "PATCH", body: JSON.stringify(body) }),
  remove: (wsId, id) => _json(`/api/kernel/workspaces/${wsId}/tasks/${id}`,
                              { method: "DELETE" }),
  explain:(wsId, id) => _json(`/api/kernel/workspaces/${wsId}/tasks/${id}/explain`),
};

// ── Hooks ────────────────────────────────────────────────
export function useWorkspaces() {
  const [workspaces, setWorkspaces] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const j = await apiWorkspace.list();
      setWorkspaces(j.workspaces || []);
      setError(null);
    } catch (e) {
      setError(e.message || "load failed");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { workspaces, loading, error, refresh };
}

export function useTasks(workspaceId) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!workspaceId) return;
    setLoading(true);
    apiTask.list(workspaceId).then((j) => setTasks(j.tasks || [])).finally(() => setLoading(false));
  }, [workspaceId]);
  return { tasks, loading };
}
